
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.32 4.177a36.958 36.958 0 012.802 4.426c1.63-.685 2.988-1.636 3.811-2.902A7.962 7.962 0 0012 4c-.577 0-1.14.06-1.68.177zm8.043 2.973c-1.078 1.47-2.646 2.513-4.345 3.245.148.317.288.632.422.943 1.989-.277 3.914-.06 5.55.242a7.957 7.957 0 00-1.627-4.43zm1.48 6.438c-1.45-.279-3.04-.477-4.647-.326a33.439 33.439 0 011.417 5.275 8.005 8.005 0 003.23-4.949zm-5.09 5.926a31.474 31.474 0 00-1.544-5.866c-2.028.618-4.078 2.004-5.826 4.886A7.96 7.96 0 0012 20c.969 0 1.895-.172 2.752-.486zm-8.87-2.357c1.906-2.988 4.198-4.604 6.571-5.368a32.983 32.983 0 00-.325-.713c-.345.104-.69.197-1.033.28-2.609.633-5.28.767-7.096.647 0 1.964.708 3.762 1.884 5.154zm-1.635-7.142c1.591.092 4.002-.027 6.376-.603.195-.047.388-.097.58-.15A35.291 35.291 0 008.348 4.88a8.02 8.02 0 00-4.1 5.135zm4.033-7.3A9.976 9.976 0 0112 2a9.97 9.97 0 016.889 2.751 9.974 9.974 0 013.072 8.135 10.005 10.005 0 01-5.675 8.151A9.965 9.965 0 0112 22a9.965 9.965 0 01-6.571-2.462 9.979 9.979 0 01-3.355-8.76 10.01 10.01 0 016.207-8.063z"}})])
          )
        }
      }
    